/**
 * Ai là "người trong" của tiểu đội Phòng KD (QĐ 0485): thấy TÊN bạn sale ở màn làm việc (26a + 2a)
 * và thấy thẻ «06 Tiểu đội» ở trang Xếp hạng (29b) — một luật cho cả hai, vì hai nhóm trùng nhau.
 * Người ngoài thấy logo + tên tiểu đội thay tên bạn sale với đơn lên từ 01/11/2026.
 *
 * Bản sao của `salessquad.Insider` (`backend/internal/core/salessquad/rules.go`): máy chủ vẫn tự
 * quyết (cửa nhãn đơn trả `showSellerName`, cửa bảng trả 403) — màn dùng bản sao để KHÔNG gọi
 * mạng cho người trong và để ẩn thẻ. Bài `permissions.test.ts` đọc tệp Go và đỏ khi lệch.
 */
export const INSIDER_ROLES = ["admin", "director", "accounting", "sale"] as const;
export const INSIDER_DEPARTMENTS = ["sale", "sales", "cskh", "accounting"] as const;

type StaffLike = { role?: string | null; department?: string | null } | null | undefined;

function norm(value: string | null | undefined): string {
  return (value ?? "").trim().toLowerCase();
}

/** Người xem thấy tên bạn sale (Phòng KD, cả phòng Kế toán, Ban giám đốc). Chưa đăng nhập ⇒ không. */
export function isSquadInsider(staff: StaffLike): boolean {
  if (!staff) return false;
  return (
    (INSIDER_ROLES as readonly string[]).includes(norm(staff.role)) ||
    (INSIDER_DEPARTMENTS as readonly string[]).includes(norm(staff.department))
  );
}

/** Thẻ «06 Tiểu đội» ở trang Xếp hạng (29b) — cùng tập người với `isSquadInsider`. */
export const canSeeSquadBoard = isSquadInsider;
